<template>
  <div class="large-offset-1">
    <h3>Eligible States</h3>
    <div class="shipping-states">
      <div v-for="state in shippingStateLabels" :key="state">
        {{ state }}
      </div>
    </div>
    <nuxt-link to="/terms/" style="font-size: small">
      * Terms and Conditions Apply
    </nuxt-link>
  </div>
</template>

<script>
import { STATE_MAPPING } from '../../config/complianceStateGroups'

export default {
  name: 'ShippingStates',
  props: {
    states: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  computed: {
    shippingStateLabels() {
      const shippingStates = [].concat(
        this.states.alt,
        this.states.main,
        this.states.private_label_only,
      )
      const passageOfTitleStates = this.states.passage_of_title
      return shippingStates
        .map((state) => {
          if (!STATE_MAPPING[state]) return null
          return (
            STATE_MAPPING[state] +
            (passageOfTitleStates.includes(state) ? '*' : '')
          )
        })
        .filter(function (v) {
          return !!v
        })
        .sort()
    },
  },
}
</script>

<style lang="scss">
.shipping-states {
  column-count: 2;
  column-gap: 1rem;
  font-size: 0.875rem;

  // Medium
  @media only screen and (max-width: 1024px) {
    column-count: 4;
  }

  // Small
  @media only screen and (max-width: 640px) {
    column-count: 2;
  }
}
</style>
